export const setLocalStorage = (key, value) => {
  var curTime = new Date().getTime();
  return localStorage.setItem(key, JSON.stringify({
    data: value,
    time: curTime
  }))
}
export const getLocalStorage = (key) => {
  var data = localStorage.getItem(key);
  //转为对象
  if (data) {
    var dataObj = JSON.parse(data);
    if (new Date().getTime() - dataObj.time > 86400000) {
      return false
    } else {
      return dataObj.data;
    }
  } else {
    return false;
  }

}
